import { render, staticRenderFns } from "./StatsSup.vue?vue&type=template&id=2f66d59e&"
import script from "./StatsSup.vue?vue&type=script&lang=js&"
export * from "./StatsSup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports